var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.458 0H1.101C.493 0 0 .496 0 1.109v5.62c0 .612.493 1.108 1.101 1.108A2.657 2.657 0 0 1 3.747 10.5 2.657 2.657 0 0 1 1.1 13.163c-.608 0-1.101.496-1.101 1.109v5.62C0 20.503.493 21 1.101 21h9.357V0zM33.899 7.837c.608 0 1.101-.496 1.101-1.109v-5.62C35 .497 34.507 0 33.899 0H12.66v21h21.238c.608 0 1.101-.496 1.101-1.109v-5.62c0-.612-.493-1.108-1.101-1.108a2.657 2.657 0 0 1-2.646-2.663A2.657 2.657 0 0 1 33.9 7.837z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingLarge);
export default __webpack_public_path__ + "static/media/booking-large.a1e4b069ad4e2d5fa1c7fddbad121f12.svg";
export { ForwardRef as ReactComponent };